import { DropdownMenuItem } from "@vg-constellation/angular-17/dropdown";

export const ACCOUNT_DETAILS_TITLED_UNDER = 'Titled under:';
export const ACCOUNT_DETAILS_CHANGE = 'Change';
export const ACCOUNT_DETAILS_INDIVIDUAL_NAME = "Individual's name";
export const ACCOUNT_DETAILS_ACCOUNT_NAME = "Account name";
export const ACCOUNT_DETAILS_ACCOUNT_NAME_PLACEHOLDER = "Enter account name";
export const ACCOUNT_DETAILS_ACCOUNT_NAME_SUB_TEXT = "This description will appear on your inventory.";
export const ACCOUNT_DETAILS_BALANCE = "Balance";
export const ACCOUNT_DETAILS_PAYABLE_ON_DEATH = "Payable on death designation";
export const ACCOUNT_DETAILS_SUBACCOUNT_TYPE = "Account type";
export const ACCOUNT_DETAILS_SUBACCOUNT_PLACEHOLDER = "Select";
export const ACCOUNT_DETAILS_NOT_SURE_CONTENT = "We'll remind you to document this owner later. It will be required to have an accurate picture of your estate plan."
export const ACCOUNT_OWNER_PRIMARY = "PRIMARY";
export const ACCOUNT_OWNER_SECONDARY = "SECONDARY";
export const ACCOUNT_OWNER_JOINT = "JOINT_OWNER";
export const ACCOUNT_DETAILS_LIABILITY_DEBTOR_TITLE = "Debtor:";
export const ACCOUNT_DETAILS_LIABILITY_DEBTOR_PLACEHOLDER = "Enter name";
export const ACCOUNT_DETAILS_LIABILITY_DEBTOR_NAME = "Liability name";

export const ACCOUNT_DETAILS_PROPERTY_NAME = "Property name";
export const ACCOUNT_DETAILS_MARKET_VALUE = "Market Value";
export const ACCOUNT_DETAILS_PROPERTY_TYPE = "Property type";
export const ACCOUNT_DETAILS_MORTGAGE_AMOUNT = "Mortgage amount (optional)";
export const ACCOUNT_DETAILS_REQUIRED_FIELDS = "All fields are required unless marked optional.";

// Trust-specific content variables
export const ACCOUNT_DETAILS_TRUST_NAME = "Trust name";
export const ACCOUNT_DETAILS_SETTLOR = "Settlor";
export const ACCOUNT_DETAILS_TRUST_LEGAL_NAME = "Trust legal name";
export const ACCOUNT_DETAILS_TRUST_TYPE = "Trust type";
export const ACCOUNT_DETAILS_TRUST_LEGAL_NAME_SUB_TEXT = "This description will appear on the personal wealth inventory.";
export const ACCOUNT_DETAILS_TRUST_DISPLAY_NAME_SUB_TEXT = "This description will appear on the personal wealth inventory.";
export const ACCOUNT_DETAILS_TRUST_REQUIRED_DESC = "All fields are required.";

export const ACCOUNT_DETAILS_MORTGAGE_DEBTOR_TITLE = "Debtor:";
export const ACCOUNT_DETAILS_MORTGAGE_DEBTOR_PLACEHOLDER = "Enter name";
export const ACCOUNT_DETAILS_MORTGAGE_DEBTOR_NAME = "Liability name";

export const ASSET_DETAILS_ASSET_NAME = "Property Name";
export const ASSET_DETAILS_ASSET_NAME_PLACEHOLDER = "Enter property name"

export const TRUST_DETAILS_TRUST_DISPLAY_NAME = "Trust display name (optional)";
export const TRUST_DETAILS_DISPLAY_NAME_DESC = "This description will appear on your inventory.";
export const TRUST_DETAILS_LEGAL_NAME_DESC = "The legally documented name of the trust within the trust agreement.";
export const TRUST_DETAILS_SETTLOR_DESC = "The person who created the trust.";

// Structured this way to fit the required format for the dropdown component
export const retirementAnnuitySubTypes: DropdownMenuItem[] = [
  {
    labelText: '401(k)',
    id: '401k'
  },
  {
    labelText: '403(b)',
    id: '403b'
  },
  {
    labelText: 'Fixed Annuity',
    id: 'fixed-annuity'
  },
  {
    labelText: 'Inherited IRA',
    id: 'inherited-ira'
  },
  {
    labelText: 'Inherited Roth IRA',
    id: 'inherited-roth-ira'
  },
  {
    labelText: 'Other Company Plan',
    id: 'other-company-plan'
  },
  {
    labelText: 'Rollover IRA',
    id: 'rollover-ira'
  },
  {
    labelText: 'Roth 401(k)',
    id: 'roth-401k'
  },
  {
    labelText: 'Roth IRA',
    id: 'roth-ira'
  },
  {
    labelText: 'SEP-IRA',
    id: 'sep-ira'
  },
  {
    labelText: 'Simple IRA',
    id: 'simple-ira'
  },
  {
    labelText: 'Traditional IRA',
    id: 'traditional-ira'
  },
  {
    labelText: 'Variable Annuity',
    id: 'variable-annuity'
  }
]

export const investmentSubTypes: DropdownMenuItem[] = [
  {
    labelText: 'Taxable account',
    id: 'taxable-account'
  }
  // TODO: Uncomment these when we need to bring these back
  // {
  //   labelText: 'Private investment',
  //   id: 'private-investment',
  // },
  // {
  //   labelText: 'Charitable account',
  //   id: 'charitable-account'
  // }
]

export const realEstateSubTypes: DropdownMenuItem[] = [
  {
    labelText: 'Investment',
    id: 'investment'
  },
  {
    labelText: 'Personal',
    id: 'personal',
  }
]

// TODO: HEYHEY PROBABLY MOVE THIS INTO THE ACCOUNT-OWNER-CONTENT.TS FILE
// Trust-specific dropdown options
export const trustSettlorTypes: DropdownMenuItem[] = [
  {
    labelText: 'PWH',
    id: 'PWH'
  },
  {
    labelText: 'Spouse',
    id: 'SPOUSE'
  },
  {
    labelText: 'Joint',
    id: 'JOINT'
  }
]

export const trustTypes: DropdownMenuItem[] = [
  {
    labelText: 'Revocable',
    id: 'REVOCABLE'
  },
  {
    labelText: 'Irrevocable',
    id: 'IRREVOCABLE'
  }
]

export const JOINT_OWNERSHIP_TYPES = {
  RIGHT_OF_SURVIVORSHIP: {
    id: 'joint-ownership-with-right-of-survivorship',
    labelText: 'Joint ownership with right of survivorship',
    value: 'JOINT_TWROS'
  },
  TENANCY_IN_COMMON: {
    id: 'joint-ownership-tenancy-in-common',
    labelText: 'Joint ownership — tenancy in common',
    value: 'JOINT_TIC'
  },
  // COMMUNITY_PROPERTY: {
  //   id: 'joint-ownership-community-property',
  //   labelText: 'Joint ownership — community property',
  //   value: 'JOINT_COMMUNITY_PROPERTY'
  // },
  // OTHER: {
  //   id: 'joint-ownership-other',
  //   labelText: 'Joint ownership — other',
  //   value: 'JOINT_OTHER'
  // }
};

// Beneficiary section
export const BENEFICIARY_SECTION_HEADER = 'Enter beneficiaries';
export const BENEFICIARY_SECTION_DISCLAIMER = 'Beneficiary details entered for non-Vanguard accounts are documented for planning purposes only and do not update or change beneficiary designations held by other institutions. Please ensure this information accurately matches beneficiary designations on non-Vanguard accounts.';
export const BENEFICIARY_CARD_HEADER = 'Beneficiary';
export const BENEFICIARY_CHOOSE_OPTION = 'Choose an option';
export const BENEFICIARY_INDIVIDUAL_BY_NAME = 'Individual by name';
export const BENEFICIARY_INDIVIDUAL_DESC = "An individual or multiple individuals will receive the proceeds from this account or asset upon the owner's incapacitation.";
export const BENEFICIARY_TRUST = 'Trust';
export const BENEFICIARY_TRUST_DESC = "This asset will be inherited by a trust and managed by the terms of the trust, upon the owner's incapacitation.";
export const BENEFICIARY_DROPDOWN_LABEL = 'Beneficiary';
export const BENEFICIARY_DROPDOWN_PLACEHOLDER = 'Select';
export const BENEFICIARY_ADD_NEW_PERSON = '+ Add new person';
export const BENEFICIARY_ALL_FIELDS_REQUIRED = 'All fields are required unless marked as optional.';
export const BENEFICIARY_FIRST_NAME_LABEL = 'First name';
export const BENEFICIARY_LAST_NAME_LABEL = 'Legal last name';
export const BENEFICIARY_DOB_LABEL = 'Date of birth (MM/DD/YYYY)';
export const BENEFICIARY_STATE_LABEL = 'State of residence';
export const BENEFICIARY_STATE_TOOLTIP = "Select 'Outside the United States' for Non-U.S. residents.";
export const BENEFICIARY_SAVE_BUTTON = 'Save beneficiary';
export const BENEFICIARY_CANCEL = 'Cancel';
export const BENEFICIARY_CHANGE = 'Change';
export const BENEFICIARY_PRIMARY_HEADER = 'Primary beneficiaries';
export const BENEFICIARY_BACKUP_HEADER = 'Backup beneficiaries';
export const BENEFICIARY_ADD_PRIMARY = 'Add primary beneficiary';
export const BENEFICIARY_ADD_BACKUP = 'Add backup beneficiary';
export const BENEFICIARY_DISTRIBUTION_LABEL = 'Distribution';
export const BENEFICIARY_PRIMARY_TOTAL_LABEL = 'Primary distribution total:';
export const BENEFICIARY_BACKUP_TOTAL_LABEL = 'Backup distribution total:';

// Beneficiary errors
export const BENEFICIARY_REQUIRED_ERROR = 'Beneficiary details are required when "Payable on death designation" is selected.';
export const BENEFICIARY_DISTRIBUTION_ERROR = 'Total distribution % must equal 100.';
export const BENEFICIARY_INCOMPLETE_ERROR = 'Please complete this beneficiary before adding another.';
export const BENEFICIARY_FIELD_REQUIRED_ERROR = 'This field is required';

// Beneficiary modals
export const BENEFICIARY_REMOVE_HEADER = 'Remove beneficiary';
export const BENEFICIARY_REMOVE_MESSAGE = 'Are you sure you want to remove this beneficiary?';
export const BENEFICIARY_REMOVE_CONFIRM = 'Remove';
export const BENEFICIARY_REMOVE_CANCEL = 'Cancel';
export const BENEFICIARY_DUPLICATE_HEADER = "You've tried to add a possible duplicate";
export const BENEFICIARY_DUPLICATE_ADD_ANYWAY = 'Add anyway';
export const BENEFICIARY_DUPLICATE_DISCARD = 'Discard and go back';
export const BENEFICIARY_DUPLICATE_PERSON_ERROR = 'This person has already been added to this section.';
export const BENEFICIARY_CREATE_PERSON_ERROR = 'Failed to save person. Please try again.';
export const BENEFICIARY_TRUST_PLACEHOLDER = 'Trust beneficiary flow will be available in a future update.';
export const BENEFICIARY_HOUSEHOLD_LOAD_ERROR = 'Failed to load household members. Please refresh and try again.';
